import { useState } from "react"
import useTopDepartments from "./useTopDepartments"
import ObjectTop from "../_shared/ObjectTop/ObjectTop"
import ObjectTopPopup from "../_shared/ObjectTop/ObjectTopPopup"

function TopDepartments() {
  const [open, setOpen] = useState(false)

  const {
    result,
    top,
    error,
    loading,
    fullMessage,
    isPeriod, setIsPeriodState,
    planTypes,
    planName,
    typeId, setTypeIdState
  } = useTopDepartments()

  return (
    <>
      <ObjectTop
        col={15}
        row={7}
        error={error}
        loading={loading}
        title={`Топ отделов по выполнению плана "${planName}"`}
        fullMessage={fullMessage}
        top={top}
        setOpenPopup={() => setOpen(true)}
        unit="%"
      />
      <ObjectTopPopup
        planTypes={planTypes}
        data={result}
        loading={loading}
        title={`Топ отделов ${planName}`}
        isPeriod={isPeriod}
        setIsPeriod={setIsPeriodState}
        onClose={() => setOpen(false)}
        open={open}
        setTypeIdState={setTypeIdState}
        typeId={typeId}
      />
    </>
  )
}

export default TopDepartments